import { LanguageCode } from '../../i18n/language.ts';
import { ProjectTranslations } from './components/project/ProjectTypes.ts';
import { pathfindingVisualizerResource } from './components/pathfindingVisualizer/PathfindingVisualizer.i18n.ts';
import { sortingVisualizerResource } from './components/sortingVisualizer/SortingVisualizer.i18n.ts';
import { lingoResource } from './components/lingo/lingo.i18n.ts';

/**
 * Projects translations structure.
 */
export interface ProjectsTranslations {
    sortingVisualizer: ProjectTranslations;
    pathfindingVisualizer: ProjectTranslations;
    lingo: ProjectTranslations;
}

/**
 * Overall translation resources structure for the projects component.
 */
export interface ProjectsResourceTranslations {
    title: string;
    projects: ProjectsTranslations;
}

/**
 * Translation resources for the projects component in different languages.
 */
type ProjectsResource = {
    [language in LanguageCode]: ProjectsResourceTranslations;
}

export const projectsResource: ProjectsResource = {
    nl: {
        title: 'Projecten',
        projects: {
            sortingVisualizer: sortingVisualizerResource.nl,
            pathfindingVisualizer: pathfindingVisualizerResource.nl,
            lingo: lingoResource.nl
        }
    },
    en: {
        title: 'Projects',
        projects: {
            sortingVisualizer: sortingVisualizerResource.en,
            pathfindingVisualizer: pathfindingVisualizerResource.en,
            lingo: lingoResource.en
        }
    }
};